var map = {
	"./angle-down.svg": 2957,
	"./angle-right.svg": 6693,
	"./arrow-down.svg": 1759,
	"./arrow-left.svg": 5648,
	"./barcode.svg": 769,
	"./battery.svg": 5958,
	"./berg.svg": 4861,
	"./card.svg": 4817,
	"./cart.svg": 6849,
	"./cash.svg": 2442,
	"./close.svg": 5837,
	"./credit-card.svg": 8531,
	"./list.svg": 71,
	"./minus.svg": 8441,
	"./plus.svg": 4491,
	"./tick.svg": 6920,
	"./wifi.svg": 5460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;